import axios from 'axios'
import Vue from 'vue';
import {
  Toast
} from 'vant';
Vue.use(Toast);

// create an axios instance
const service = axios.create({
   baseURL: 'https://xndapplet.xinnongrenxueshe.cn/v1', // 正式

   //baseURL:'http://xndapplet.xinnongrenxueshe.net/v1', //测试
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

service.interceptors.request.use(
  config => {
   /*  if (store.getters.token) {
    config.headers['token'] = getToken()
     } */
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.resCode !== 200) {
      if (res.resCode !== 40005) {
        Toast.fail(res.resMsg);
      } else {
        if (localStorage.getItem('tips') !== res.resMsg) {
          localStorage.setItem('tips', res.resMsg)
          Toast.fail(res.resMsg);
          // token失效
          setTimeout(() => {
            //store.dispatch('user/logout').then(() => {
            localStorage.setItem('tips', '')
            location.reload()
          })
          //}, 1000)
        }
      }
      return Promise.reject(res)
    } else {
      return res
    }
  },
  error => {
    Toast.fail(res.resMsg);
    return Promise.reject(error)
  }
)

/**
 * https://github.com/scopsy/await-to-js
 * 包装请求请求promise返回数据的格式：[正常数据，异常数据]
 * 适用于async/await形式的写法，可以避免使用try catch处理异常返回的数据
 * @param promise
 * @returns {Q.Promise<*[]>}
 */
const to = (promise) => {
  return promise
    .then(data => {
      return [data, null]
    })
    .catch(err => {
      return [undefined, err]
    })
}

/**
 * 请求
 * 返回数据格式经过to方法处理
 */
function fetch(data) {
  return to(service(data))
}

export default fetch



// WEBPACK FOOTER //
// ./src/utils/newRequest.js